import { Link } from "react-router-dom";
import { Quote, Radio, ArrowRight } from "lucide-react";
import { TEAM } from "@/lib/team-data";

const STUDIO = "/assets/studio-team.png";

export default function About() {
  return (
    <div data-testid="page-about" className="bg-[#F7F5F0]">
      {/* Hero */}
      <section className="relative min-h-[60vh] overflow-hidden">
        <div className="absolute inset-0">
          <img src={STUDIO} alt="" className="w-full h-full object-cover jt-pan" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#2E4959]/85 via-[#4A6D82]/70 to-[#F7F5F0]" />
        </div>
        <div className="relative max-w-5xl mx-auto px-6 pt-40 pb-24 text-center">
          <span className="text-xs uppercase tracking-[0.3em] text-[#F4E4C1]">Qui sommes-nous</span>
          <h1 className="font-serif text-5xl md:text-7xl leading-[1.05] text-white mt-4 mb-5">
            Une vision.<br /><em className="not-italic text-[#F4E4C1]">Trois voix</em>.
          </h1>
          <p className="text-lg text-white/85 max-w-2xl mx-auto">
            Jesus Talk est un média chrétien né d'une vision que Dieu a révélée : développer la vie spirituelle et la relation avec Jésus à travers des podcasts et des contenus qui parlent vrai.
          </p>
        </div>
      </section>

      {/* Vision */}
      <section className="py-20 md:py-24 bg-white" data-testid="section-vision">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <span className="text-xs uppercase tracking-[0.3em] text-[#4A6D82]">Notre vision</span>
          <h2 className="font-serif text-4xl md:text-6xl leading-[1.05] text-[#1E2933] mt-3 mb-8">
            Faire naître la foi <em className="not-italic text-[#4A6D82]">par ce que l'on entend</em>.
          </h2>
          <p className="text-[#1E2933]/80 text-lg leading-relaxed mb-6">
            Tout est parti d'une révélation donnée à Laetitia : ouvrir un espace de média chrétien pour que chacun puisse développer sa vie spirituelle et sa relation avec Jésus, à travers des podcasts et d'autres supports de communication accessibles.
          </p>
          <p className="text-[#1E2933]/80 text-lg leading-relaxed">
            Jesus Talk n'est pas d'abord une organisation : c'est une porte, un pont, une voix. Une invitation à écouter, à croire, à marcher.
          </p>
          <p className="font-serif italic text-2xl text-[#4A6D82] border-l-2 border-[#C99A5B] pl-6 max-w-2xl mx-auto text-left mt-10">
            « Ainsi la foi vient de ce qu'on entend, et ce qu'on entend vient de la parole de Christ. »<br />
            <span className="text-base text-[#6B7A85] not-italic">— Romains 10:17</span>
          </p>
        </div>
      </section>

      {/* Team */}
      <section className="py-20 md:py-24 bg-[#F7F5F0]" data-testid="section-team">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="text-xs uppercase tracking-[0.3em] text-[#4A6D82]">L'équipe</span>
            <h2 className="font-serif text-4xl md:text-5xl text-[#1E2933] mt-3">L'Équipe de Jesus Talk</h2>
          </div>

          <div className="space-y-16">
            {TEAM.map((m, i) => (
              <div
                key={m.id}
                className={`grid md:grid-cols-12 gap-8 md:gap-12 items-center ${i % 2 === 1 ? "md:[direction:rtl]" : ""}`}
                data-testid={`team-${m.id}`}
              >
                <div className="md:col-span-5 [direction:ltr]">
                  <div className="relative aspect-[4/5] rounded-3xl overflow-hidden jt-medium-shadow">
                    <img src={m.image} alt={m.name} className="absolute inset-0 w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
                  </div>
                </div>
                <div className="md:col-span-7 [direction:ltr]">
                  <span className="text-xs uppercase tracking-[0.3em] text-[#C99A5B]">{m.role}</span>
                  <h3 className="font-serif text-5xl md:text-6xl text-[#1E2933] mt-2 mb-4 leading-none">{m.name}</h3>
                  <p className="relative pl-6 border-l-2 border-[#4A6D82] font-serif italic text-2xl text-[#4A6D82] mb-6">
                    « {m.tagline} »
                  </p>
                  <p className="text-[#1E2933]/80 text-lg leading-relaxed">{m.long}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 md:py-24 bg-[#4A6D82] text-white">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <Quote className="w-10 h-10 mx-auto text-[#F4E4C1] mb-6" strokeWidth={1.5} />
          <p className="font-serif italic text-3xl md:text-4xl leading-tight mb-8">
            « Le média qui encourage ta foi au quotidien. »
          </p>
          <div className="flex flex-wrap gap-3 justify-center">
            <Link to="/podcasts" className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-white text-[#2E4959] hover:bg-[#F4E4C1] transition">
              <Radio className="w-4 h-4" /> Écouter les podcasts
            </Link>
            <Link to="/contact" className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full border border-white/40 text-white hover:bg-white/10 transition">
              Nous inviter <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
